module.exports = {
  "country": "RO",
  "artist": "Cezar",
  "song": "Its my Life",
  "year": "2013",
  "place": "13",
  "spotify": "1RCLwB4gj44JWKtjn0Kwok"
};